import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { Occurrence } from '@klopotun/contracts';
import { occurrenceQueries } from './occurrence-queries.js';

export const useOccurrenceQuery = (id: string): UseQueryResult<Occurrence> =>
  useQuery(occurrenceQueries.detail(id));
